


export const TextInput = ({placeholder, value, setValue=()=>{}, backgroundColor, width, height, fontSize, padding, titleFontSize=24, multiline=false, bottomComponent=null}) => {

  return (
    <div className={'text-input-wrapper relative'}>
      {!multiline && <div className={'blur-white font-24'} style={{fontSize: titleFontSize}}>{placeholder}</div>}
      {multiline ?
        <textarea className={'text-input notosans-regular text-area'}
               style={{backgroundColor, width, height, fontSize, padding, border: backgroundColor ? 'none' : null}} value={value}
               onChange={e => setValue(e.target.value)} placeholder={placeholder}/>
        :
        <input className={'text-input notosans-regular white-border-bottom'}
               style={{backgroundColor, width, height, fontSize, padding, border: backgroundColor ? 'none' : null}} value={value}
               onChange={e => setValue(e.target.value)}/>
      }
      {bottomComponent && bottomComponent}
    </div>
  )
}
